import React from 'react';
import { View, Text, Link, AppHeader, Clipboard, WebBrowser } from 'core';
import { css, theme } from 'constants';
import { lang } from 'lang';
import { IcoAccount, IcoPM, IcoPhone, IcoHome, IcoCall, IcoCopy } from 'icons';

const ContactProfile = ({ contact }) => (
  <View>
    {console.log(contact)}
    <AppHeader title={lang.PROFILE} close />
    <View style={styles.container}>
      <View style={styles.name_cont}>
        <IcoAccount style={styles.avatar} size={64} color={theme.gray_color_lighten(0.4)} />
        <Text style={{ fontSize: theme.font_lg }}>{contact.name}</Text>
      </View>
      {contact.phone_num.map(e => (
        <View style={styles.row} key={e.number} onPress={() => {}}>
          {e.label === 'home' ? <IcoHome size={25} style={styles.label_icon} /> : <IcoPhone size={25} style={styles.label_icon} />}
          <View style={styles.contact_num}>
            <Text style={{ fontSize: theme.font_md }}>{contact && e.number}</Text>
            <Text style={{ color: theme.primary_color }}>{e.label}</Text>
          </View>
          <View style={styles.action}>
            <Link icon={IcoCall} size={15} color={theme.primary_color} onPress={() => WebBrowser.goToTel(e.number)} style={styles.action_icon} />
            <Link
              icon={IcoCopy}
              size={15}
              color={theme.primary_color}
              onPress={() => {
                Clipboard.setString(e.number);
              }}
              style={styles.action_icon}
            />
            <Link icon={IcoPM} size={15} color={theme.primary_color} onPress={() => WebBrowser.goToSms(e.number)} style={styles.action_icon} />
          </View>
        </View>
      ))}
    </View>
  </View>
);

const styles = css({
  container: {
    padding: 10
  },
  name_cont: {
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 70
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 50,
    padding: 10
  },
  contact_num: {
    flex: 1
  },
  label_icon: {
    marginRight: 5
  },
  action: {
    flexDirection: 'row'
  },
  action_icon: {
    margin: 5,
    padding: 5
  }
});
export default ContactProfile;



// WEBPACK FOOTER //
// ./src/components/modals/contact_profile.js